import { appApi, createJsonAccessToken } from './apiInstance';
import { appConfig } from '../config/runtimeConfig';

const apiUrl = appConfig.gatewayUrl;

const mainContext = 'talent';

const headerMultiFormData = accessToken => {
    return {
        ...createJsonAccessToken(accessToken),
        contentType: 'multipart/form-data'
    }
};

export const testConnection = accessToken => appApi(apiUrl, createJsonAccessToken(accessToken)).get(`${mainContext}/test`);

export const getTalent = (talentId, accessToken) => appApi(apiUrl, createJsonAccessToken(accessToken)).get(`${mainContext}/${talentId}`);

export const getTalentByEmail = (email, accessToken) => appApi(apiUrl, createJsonAccessToken(accessToken)).get(`${mainContext}/email/${email}/entity`);

export const saveTalent = (request, accessToken) => appApi(apiUrl, headerMultiFormData(accessToken)).post(`${mainContext}/new`, request);

export const updateTalent = (request, accessToken) => appApi(apiUrl, headerMultiFormData(accessToken)).put(`${mainContext}/edit?sectionId=1`, request);

export const acceptImprovementActions = feedbackId => appApi(apiUrl).put(`feedback/${feedbackId}/accept-improvement-actions`);
